export default __webpack_public_path__ + "static/Live-Video_AVIRA-ee951f5461463d805420ab4c9481ff6f.webp";